/**
 * LED component catalog synchronized from the Mugnee price database.
 * Admin price updates replace the values in this object automatically.
 */
export const componentModelAndPrice = {
  "schemaVersion": 1,
  "modelGroups": {
    "smd": {
      "indoor": [
        { "id": "smd-in-p1_25", "name": "P1.25", "prices": { "default": 9300 } },
        { "id": "smd-in-p1_53", "name": "P1.53", "prices": { "default": 6082 } },
        { "id": "smd-in-p1_86", "name": "P1.86", "prices": { "default": 4020 } },
        { "id": "smd-in-p2", "name": "P2", "prices": { "default": 3000 } },
        { "id": "smd-in-p2_5", "name": "P2.5", "prices": { "default": 2350 } },
        { "id": "smd-in-p3", "name": "P3", "prices": { "default": 2850 } }
      ],
      "outdoor": [
        { "id": "smd-out-p2_5", "name": "P2.5", "prices": { "default": 6500 } },
        { "id": "smd-out-p3", "name": "P3", "prices": { "default": 2618 } },
        { "id": "smd-out-p3.91", "name": "P3.91", "prices": { "default": 3500 } },
        { "id": "smd-out-p4", "name": "P4", "prices": { "default": 2850 } },
        { "id": "smd-out-p5", "name": "P5", "prices": { "default": 2350 } },
        { "id": "smd-out-p6", "name": "P6", "prices": { "default": 1860 } },
        { "id": "smd-out-p6_67", "name": "P6.67", "prices": { "default": 2205 } },
        { "id": "smd-out-p8", "name": "P8", "prices": { "default": 1929 } },
        { "id": "smd-out-p10", "name": "P10", "prices": { "default": 1677 } }
      ]
    },
    "gob": {
      "indoor": [
        { "id": "gob-in-p1_25", "name": "P1.25", "prices": { "default": 5800 } },
        { "id": "gob-in-p1_53", "name": "P1.53", "prices": { "default": 4600 } },
        { "id": "gob-in-p1_86", "name": "P1.86", "prices": { "default": 4350 } },
        { "id": "gob-in-p2", "name": "P2", "prices": { "default": 3618 } },
        { "id": "gob-in-p2.5", "name": "P2.5", "prices": { "default": 2950 } },
        { "id": "gob-in-p3", "name": "P3", "prices": { "default": 4000 } }
      ]
    },
    "cob": {
      "indoor": [
        { "id": "cob-in-p1_25", "name": "P1.25", "prices": { "default": 13000 } },
        { "id": "cob-in-p1_53", "name": "P1.53", "prices": { "default": 8700 } },
        { "id": "cob-in-p1_86", "name": "P1.86", "prices": { "default": 5800 } }
      ]
    }
  },
  "moduleBrandPrices": {
    "Lampro": {
      "smd-in-p1_25": { "default": 9300 },
      "smd-in-p1_53": { "default": 6082 },
      "smd-in-p1_86": { "default": 4020 },
      "smd-in-p2": { "default": 3000 },
      "smd-in-p2_5": { "default": 2350 },
      "smd-in-p3": { "default": 2850 },
      "smd-out-p2_5": { "default": 6500 },
      "smd-out-p3": { "default": 2618 },
      "smd-out-p3.91": { "default": 3500 },
      "smd-out-p4": { "default": 2850 },
      "smd-out-p5": { "default": 2350 },
      "smd-out-p6": { "default": 1860 },
      "smd-out-p6_67": { "default": 2205 },
      "smd-out-p8": { "default": 1929 },
      "smd-out-p10": { "default": 1677 },
      "gob-in-p1_25": { "default": 5800 },
      "gob-in-p1_53": { "default": 4600 },
      "gob-in-p1_86": { "default": 4350 },
      "gob-in-p2": { "default": 3618 },
      "gob-in-p2.5": { "default": 2950 },
      "gob-in-p3": { "default": 4000 },
      "cob-in-p1_25": { "default": 13000 },
      "cob-in-p1_53": { "default": 8700 },
      "cob-in-p1_86": { "default": 5800 }
    },
    "Absen": {
      "smd-in-p1_25": { "default": 9450 },
      "smd-in-p1_53": { "default": 6232 },
      "smd-in-p1_86": { "default": 4170 },
      "smd-in-p2": { "default": 3150 },
      "smd-in-p2_5": { "default": 2500 },
      "smd-in-p3": { "default": 3000 },
      "smd-out-p2_5": { "default": 6650 },
      "smd-out-p3": { "default": 2768 },
      "smd-out-p3.91": { "default": 3650 },
      "smd-out-p4": { "default": 3000 },
      "smd-out-p5": { "default": 2500 },
      "smd-out-p6": { "default": 2010 },
      "smd-out-p6_67": { "default": 2355 },
      "smd-out-p8": { "default": 2079 },
      "smd-out-p10": { "default": 1827 },
      "gob-in-p1_25": { "default": 5950 },
      "gob-in-p1_53": { "default": 4750 },
      "gob-in-p1_86": { "default": 4500 },
      "gob-in-p2": { "default": 3768 },
      "gob-in-p2.5": { "default": 3100 },
      "gob-in-p3": { "default": 4150 },
      "cob-in-p1_25": { "default": 12650 },
      "cob-in-p1_53": { "default": 8850 },
      "cob-in-p1_86": { "default": 5950 }
    },
    "Leyard": {
      "smd-in-p1_25": { "default": 9550 },
      "smd-in-p1_53": { "default": 6332 },
      "smd-in-p1_86": { "default": 4270 },
      "smd-in-p2": { "default": 3250 },
      "smd-in-p2_5": { "default": 2600 },
      "smd-in-p3": { "default": 3100 },
      "smd-out-p2_5": { "default": 6750 },
      "smd-out-p3": { "default": 2868 },
      "smd-out-p3.91": { "default": 3750 },
      "smd-out-p4": { "default": 3000 },
      "smd-out-p5": { "default": 2600 },
      "smd-out-p6": { "default": 2110 },
      "smd-out-p6_67": { "default": 2455 },
      "smd-out-p8": { "default": 2179 },
      "smd-out-p10": { "default": 1927 },
      "gob-in-p1_25": { "default": 6050 },
      "gob-in-p1_53": { "default": 4850 },
      "gob-in-p1_86": { "default": 4600 },
      "gob-in-p2": { "default": 3868 },
      "gob-in-p2.5": { "default": 3200 },
      "gob-in-p3": { "default": 4250 },
      "cob-in-p1_25": { "default": 12750 },
      "cob-in-p1_53": { "default": 8950 },
      "cob-in-p1_86": { "default": 6050 }
    },
    "Synoveta": {
      "smd-in-p1_25": { "default": 9050 },
      "smd-in-p1_53": { "default": 5832 },
      "smd-in-p1_86": { "default": 3770 },
      "smd-in-p2": { "default": 2750 },
      "smd-in-p2_5": { "default": 2100 },
      "smd-in-p3": { "default": 2600 },
      "smd-out-p2_5": { "default": 6250 },
      "smd-out-p3": { "default": 2368 },
      "smd-out-p3.91": { "default": 3250 },
      "smd-out-p4": { "default": 2600 },
      "smd-out-p5": { "default": 2100 },
      "smd-out-p6": { "default": 1610 },
      "smd-out-p6_67": { "default": 1955 },
      "smd-out-p8": { "default": 1679 },
      "smd-out-p10": { "default": 1427 },
      "gob-in-p1_25": { "default": 5550 },
      "gob-in-p1_53": { "default": 4350 },
      "gob-in-p1_86": { "default": 4100 },
      "gob-in-p2": { "default": 3368 },
      "gob-in-p2.5": { "default": 2700 },
      "gob-in-p3": { "default": 3750 },
      "cob-in-p1_25": { "default": 12750 },
      "cob-in-p1_53": { "default": 8450 },
      "cob-in-p1_86": { "default": 5550 }
    }
  },
  "moduleBrandModelNames": {
    "Lampro": {
      "smd-in-p1_25": "LC1.25P",
      "smd-in-p1_53": "LC1.53P",
      "smd-in-p1_86": "LC1.86P",
      "smd-in-p2": "LC2P",
      "smd-in-p2_5": "LC2.5P",
      "smd-in-p3": "LC3P",
      "smd-out-p2_5": "LC2.5PO",
      "smd-out-p3": "LC3.076PO",
      "smd-out-p3.91": "LR3.91O",
      "smd-out-p4": "LC4PO",
      "smd-out-p5": "LC5PO",
      "smd-out-p6": "LC6PO",
      "smd-out-p6_67": "LC6.667PO",
      "smd-out-p8": "LC8PO",
      "smd-out-p10": "LC10PO",
      "gob-in-p1_25": "LC1.25P GOB",
      "gob-in-p1_53": "LC1.53P GOB",
      "gob-in-p1_86": "LC1.86P GOB",
      "gob-in-p2": "LC2P GOB",
      "gob-in-p2.5": "LC2.5P GOB",
      "gob-in-p3": "LC3P GOB",
      "cob-in-p1_25": "LC COB 1.25",
      "cob-in-p1_53": "LC COB 1.53",
      "cob-in-p1_86": "LC COB 1.86"
    },
    "Absen": {
      "smd-in-p1_25": "P1.25",
      "smd-in-p1_53": "P1.53",
      "smd-in-p1_86": "P1.86",
      "smd-in-p2": "P2",
      "smd-in-p2_5": "P2.5",
      "smd-in-p3": "P3",
      "smd-out-p2_5": "P2.5",
      "smd-out-p3": "P3",
      "smd-out-p3.91": "P3.91",
      "smd-out-p4": "P4",
      "smd-out-p5": "P5",
      "smd-out-p6": "P6",
      "smd-out-p6_67": "P6.67",
      "smd-out-p8": "P8",
      "smd-out-p10": "P10",
      "gob-in-p1_25": "P1.25",
      "gob-in-p1_53": "P1.53",
      "gob-in-p1_86": "P1.86",
      "gob-in-p2": "P2",
      "gob-in-p2.5": "P2.5",
      "gob-in-p3": "P3",
      "cob-in-p1_25": "P1.25",
      "cob-in-p1_53": "P1.53",
      "cob-in-p1_86": "P1.86"
    },
    "Leyard": {
      "smd-in-p1_25": "P1.25",
      "smd-in-p1_53": "P1.53",
      "smd-in-p1_86": "P1.86",
      "smd-in-p2": "P2",
      "smd-in-p2_5": "P2.5",
      "smd-in-p3": "P3",
      "smd-out-p2_5": "P2.5",
      "smd-out-p3": "P3",
      "smd-out-p3.91": "P3.91",
      "smd-out-p4": "P4",
      "smd-out-p5": "P5",
      "smd-out-p6": "P6",
      "smd-out-p6_67": "P6.67",
      "smd-out-p8": "P8",
      "smd-out-p10": "P10",
      "gob-in-p1_25": "P1.25",
      "gob-in-p1_53": "P1.53",
      "gob-in-p1_86": "P1.86",
      "gob-in-p2": "P2",
      "gob-in-p2.5": "P2.5",
      "gob-in-p3": "P3",
      "cob-in-p1_25": "P1.25",
      "cob-in-p1_53": "P1.53",
      "cob-in-p1_86": "P1.86"
    },
    "Synoveta": {
      "smd-in-p1_25": "SVC 1.25P",
      "smd-in-p1_53": "SVC 1.53P",
      "smd-in-p1_86": "SVC 1.86P",
      "smd-in-p2": "P2",
      "smd-in-p2_5": "P2.5",
      "smd-in-p3": "P3",
      "smd-out-p2_5": "P2.5",
      "smd-out-p3": "P3",
      "smd-out-p3.91": "P3.91",
      "smd-out-p4": "P4",
      "smd-out-p5": "P5",
      "smd-out-p6": "P6",
      "smd-out-p6_67": "P6.67",
      "smd-out-p8": "P8",
      "smd-out-p10": "P10",
      "gob-in-p1_25": "P1.25",
      "gob-in-p1_53": "P1.53",
      "gob-in-p1_86": "P1.86",
      "gob-in-p2": "P2",
      "gob-in-p2.5": "P2.5",
      "gob-in-p3": "P3",
      "cob-in-p1_25": "SVC 1.25P",
      "cob-in-p1_53": "SVC 1.53P",
      "cob-in-p1_86": "SVC 1.86P"
    }
  },
  "moduleBrandGoldAdjustments": {
    "Absen": 150
  },
  "controllers": [
    { "id": "WF1", "unit": "Pcs", "brand": "Huidu", "label": "Control Card WF1", "model": "Control Card WF1", "price": 562, "itemName": "Control Card WF1" },
    { "id": "WF2", "unit": "Pcs", "brand": "Huidu", "label": "Control Card WF2", "model": "Control Card WF2", "price": 687, "itemName": "Control Card WF2" },
    { "id": "WF4", "unit": "Pcs", "brand": "Huidu", "label": "Control Card WF4", "model": "Control Card WF4", "price": 1109, "itemName": "Control Card WF4" },
    { "id": "A3L", "unit": "Pcs", "brand": "Huidu", "label": "Crontoller: HD-A3L", "model": "HD-A3L", "price": 23400, "itemName": "Crontoller: HD-A3L" },
    { "id": "A5L", "unit": "Pcs", "brand": "Huidu", "label": "Crontoller: HD-A5L", "model": "HD-A5L", "price": 30500, "itemName": "Crontoller: HD-A5L" },
    { "id": "C16L", "unit": "Pcs", "brand": "Huidu", "label": "C16L Controller", "model": "C16L Controller", "price": 18000, "itemName": "C16L Controller" },
    { "id": "VP210H", "unit": "Pcs", "brand": "Huidu", "label": "Video Processor: HD VP210H", "model": "HD VP210H", "price": 27600, "itemName": "Video Processor: HD VP210H" },
    { "id": "VP410H", "unit": "Pcs", "brand": "Huidu", "label": "Video Processor: HD VP410H", "model": "HD VP410H", "price": 33000, "itemName": "Video Processor: HD VP410H" },
    { "id": "VP630", "unit": "Pcs", "brand": "Huidu", "label": "Video Processor: HD-VP630 ", "model": "HD-VP630", "price": 79000, "itemName": "Video Processor: HD-VP630 " },
    { "id": "VP830", "unit": "Pcs", "brand": "Huidu", "label": "Video Processor: HD VP830", "model": "HD VP830", "price": 109000, "itemName": "Video Processor: HD VP830" },
    { "id": "VP1240A", "unit": "Pcs", "brand": "Huidu", "label": "HD VP1240A", "model": "HD VP1240A", "price": 138000, "itemName": "HD VP1240A" },
    { "id": "VP1220S", "unit": "Pcs", "brand": "Huidu", "label": "HD VP1220S", "model": "HD VP1220S", "price": 85025, "itemName": "HD VP1220S" },
    { "id": "A6L", "unit": "Pcs", "brand": "Huidu", "label": "Crontoller: HD-A6L", "model": "HD-A6L", "price": 43000, "itemName": "Crontoller: HD-A6L" },
    { "id": "VP1620S", "unit": "Pcs", "brand": "Huidu", "label": "HD VP1620S", "model": "HD VP1620S", "price": 150000, "itemName": "HD VP1620S" },
    { "id": "VP1640A", "unit": "Pcs", "brand": "Huidu", "label": "HD VP1640A", "model": "HD VP1640A", "price": 166800, "itemName": "HD VP1640A" }
  ],
  "ctrlCap": {
    "indoor": [
      { "id": "VP210H", "max": 1200000 },
      { "id": "VP410H", "max": 2500000 },
      { "id": "VP630", "max": 3750000 },
      { "id": "VP830", "max": 5050000 },
      { "id": "VP1240A", "max": 7550000 },
      { "id": "VP1640A", "max": 9940000 }
    ],
    "outdoor": [
      { "id": "A3L", "max": 550000 },
      { "id": "A5L", "max": 1150000 },
      { "id": "A6L", "max": 2500000 }
    ]
  },
  "priceTiers": [
    { "id": "gold", "label": "Gold", "note": "Standard", "warrantyYears": 1 },
    { "id": "platinum", "label": "Platinum", "note": "15% premium", "warrantyYears": 2 },
    { "id": "diamond", "label": "Diamond", "note": "25% premium", "warrantyYears": 3 }
  ],
  "technologiesAll": [
    { "id": "smd", "label": "SMD" },
    { "id": "gob", "label": "GOB" },
    { "id": "cob", "label": "COB" }
  ],
  "paymentTerms": [
    { "id": "PT_100", "label": "100% Advance" },
    { "id": "PT_75_25", "label": "75% Advance, 25% before Installation" },
    { "id": "PT_50_50", "label": "50% Advance, 50% before Installation" },
    { "id": "PT_NO_ADV_7D", "label": "No Advance, pay within 7 days of Delivery" }
  ],
  "moduleBrands": [
    { "value": "Absen", "label": "Absen" },
    { "value": "Lampro", "label": "Lampro" },
    { "value": "Leyard", "label": "Leyard" },
    { "value": "Synoveta", "label": "Synoveta" }
  ],
  "controllerSystemBrands": [
    { "value": "Huidu", "label": "Huidu" },
    { "value": "Novastar", "label": "Novastar" }
  ],
  "novastarControllers": [
    { "id": "NS_TB40", "unit": "Pcs", "brand": "Novastar", "label": "Controller: TB-40", "model": "TB-40", "price": 40000, "itemName": "Controller: TB-40" },
    { "id": "NS_TB50", "unit": "Pcs", "brand": "Novastar", "label": "Controller: TB-50", "model": "TB-50", "price": 57000, "itemName": "Controller: TB-50" },
    { "id": "NS_TB60", "unit": "Pcs", "brand": "Novastar", "label": "Controller: TB-60", "model": "TB-60", "price": 75500, "itemName": "Controller: TB-60" },
    { "id": "NS_TU15PRO", "unit": "Pcs", "brand": "Novastar", "label": "Controller: TU-15 Pro", "model": "TU-15 Pro", "price": 150000, "itemName": "Controller: TU-15 Pro" },
    { "id": "NS_TU20PRO", "unit": "Pcs", "brand": "Novastar", "label": "Controller: TU-20 Pro", "model": "TU-20 Pro", "price": 180000, "itemName": "Controller: TU-20 Pro" },
    { "id": "NS_TU40PRO", "unit": "Pcs", "brand": "Novastar", "label": "Controller: TU-40 Pro", "model": "TU-40 Pro", "price": 312000, "itemName": "Controller: TU-40 Pro" },
    { "id": "NS_VX2000", "unit": "Pcs", "brand": "Novastar", "label": "Video Processor: VX2000 Pro", "model": "VX2000 Pro", "price": 560000, "itemName": "Video Processor: VX2000 Pro" },
    { "id": "NS_TB1", "unit": "Pcs", "brand": "Novastar", "label": "Controller: TB-1", "model": "TB-1", "price": 21000, "itemName": "Controller: TB-1" },
    { "id": "NS_VX400", "unit": "Pcs", "brand": "Novastar", "label": "Video Processor: VX400 Pro", "model": "VX400 Pro", "price": 198000, "itemName": "Video Processor: VX400 Pro" },
    { "id": "NS_VX1000", "unit": "Pcs", "brand": "Novastar", "label": "Video Processor: VX1000 Pro", "model": "VX1000 Pro", "price": 280000, "itemName": "Video Processor: VX1000 Pro" },
    { "id": "NS_VX600", "unit": "Pcs", "brand": "Novastar", "label": "Video Processor: VX600 Pro", "model": "VX600 Pro", "price": 215000, "itemName": "Video Processor: VX600 Pro" }
  ],
  "novastarCtrlCap": {
    "indoor": [
      { "id": "NS_TB40", "max": 0 },
      { "id": "NS_TB50", "max": 0 },
      { "id": "NS_TB60", "max": 0 },
      { "id": "NS_TU15PRO", "max": 2400000 },
      { "id": "NS_TU20PRO", "max": 3750000 },
      { "id": "NS_TU40PRO", "max": 12800000 },
      { "id": "NS_VX400", "max": 2450000 },
      { "id": "NS_VX600", "max": 3800000 },
      { "id": "NS_VX1000", "max": 6300000 },
      { "id": "NS_VX2000", "max": 12820000 }
    ],
    "outdoor": [
      { "id": "NS_TB1", "max": 0 },
      { "id": "NS_TB40", "max": 1150000 },
      { "id": "NS_TB50", "max": 0 },
      { "id": "NS_TB60", "max": 2200000 },
      { "id": "NS_TU15PRO", "max": 2400000 },
      { "id": "NS_TU20PRO", "max": 3750000 },
      { "id": "NS_TU40PRO", "max": 12800000 },
      { "id": "NS_VX400", "max": 2450000 },
      { "id": "NS_VX600", "max": 3800000 },
      { "id": "NS_VX1000", "max": 6300000 },
      { "id": "NS_VX2000", "max": 12820000 }
    ]
  },
  "receivingCards": {
    "NS_NV3210": { "id": "NS_NV3210", "pin": 26, "unit": "Pcs", "brand": "Novastar", "label": "Receiving Card: NV3210", "model": "NV3210", "itemName": "Receiving Card: NV3210", "unitPrice": 4000 },
    "NS_NV7512": { "id": "NS_NV7512", "pin": 16, "unit": "Pcs", "brand": "Novastar", "label": "Receiving Card: NV7512", "model": "NV7512", "itemName": "Receiving Card: NV7512", "unitPrice": 2900 },
    "NS_A5S_26": { "id": "NS_A5S_26", "pin": 26, "unit": "Pcs", "brand": "Novastar", "label": "Receiving Card: A5s Plus", "model": "A5s Plus", "itemName": "Receiving Card: A5s Plus", "unitPrice": 3100 },
    "NS_A5S_16": { "id": "NS_A5S_16", "pin": 16, "unit": "Pcs", "brand": "Novastar", "label": "Receiving Card: A5s Plus", "model": "A5s Plus", "itemName": "Receiving Card: A5s Plus", "unitPrice": 2600 },
    "R732": { "id": "R732", "unit": "Pcs", "brand": "Huidu", "label": "Receiving Card: R-732", "model": "R-732", "itemName": "Receiving Card: R-732", "unitPrice": 2950, "cobUnitPrice": 2900 },
    "R712": { "id": "R712", "unit": "Pcs", "brand": "Huidu", "label": "Receiving Card: R-712", "model": "R-712", "itemName": "Receiving Card: R-712", "unitPrice": 2500 }
  },
  "powerSupplies": [
    { "id": "PS_LD200", "label": "Power Supply: LD-200", "price": 1600, "itemName": "Power Supply: LD-200", "brand": "Lampro", "model": "LD-200", "unit": "Pcs" },
    { "id": "PS_LRS200", "label": "Power Supply: LRS-200", "price": 1600, "itemName": "Power Supply: LRS-200", "brand": "Mean well", "model": "LRS-200", "unit": "Pcs" },
    { "id": "PS_N200V5A", "label": "Power Supply: N200V5-A", "price": 1600, "itemName": "Power Supply: N200V5-A", "brand": "G-Energy", "model": "N200V5-A", "unit": "Pcs" }
  ],
  "cabinetCasePrice": 8000,
  "modulesPerCabinet": 6,
  "cabinetOptions": [
    { "id": "cabinet_indoor_aluminium_640x480", "unit": "Pcs", "brand": "", "label": "640mm x 480mm", "model": "", "price": 8000, "sizeKey": "640x480", "widthMm": 640, "heightMm": 480, "itemName": "Aluminium 640mm x 480mm", "sourceKey": "led:cabinet:cabinet_indoor_aluminium_640x480", "catalogRole": "base", "displayType": "indoor", "variantCode": "", "materialCode": "aluminium", "variantLabel": "", "materialLabel": "Aluminium", "sourceCatalog": "static-js", "modulesPerCabinet": 6 },
    { "id": "cabinet_indoor_aluminium_640x640", "unit": "Pcs", "brand": "", "label": "640mm x 640mm", "model": "", "price": 8000, "sizeKey": "640x640", "widthMm": 640, "heightMm": 640, "itemName": "Aluminium 640mm x 640mm", "sourceKey": "led:cabinet:cabinet_indoor_aluminium_640x640", "catalogRole": "base", "displayType": "indoor", "variantCode": "", "materialCode": "aluminium", "variantLabel": "", "materialLabel": "Aluminium", "sourceCatalog": "static-js", "modulesPerCabinet": 8 },
    { "id": "cabinet_outdoor_mild_steel_open_640x480", "unit": "Pcs", "brand": "", "label": "640mm x 480mm", "model": "", "price": 8000, "sizeKey": "640x480", "widthMm": 640, "heightMm": 480, "itemName": "Mild Steel Open 640mm x 480mm", "sourceKey": "led:cabinet:cabinet_outdoor_mild_steel_open_640x480", "catalogRole": "base", "displayType": "outdoor", "variantCode": "open", "materialCode": "mild_steel", "variantLabel": "Open", "materialLabel": "Mild Steel", "sourceCatalog": "static-js", "modulesPerCabinet": 6 },
    { "id": "cabinet_outdoor_mild_steel_open_640x640", "unit": "Pcs", "brand": "", "label": "640mm x 640mm", "model": "", "price": 8000, "sizeKey": "640x640", "widthMm": 640, "heightMm": 640, "itemName": "Mild Steel Open 640mm x 640mm", "sourceKey": "led:cabinet:cabinet_outdoor_mild_steel_open_640x640", "catalogRole": "base", "displayType": "outdoor", "variantCode": "open", "materialCode": "mild_steel", "variantLabel": "Open", "materialLabel": "Mild Steel", "sourceCatalog": "static-js", "modulesPerCabinet": 8 },
    { "id": "cabinet_outdoor_mild_steel_open_960x960", "unit": "Pcs", "brand": "", "label": "960mm x 960mm", "model": "", "price": 8000, "sizeKey": "960x960", "widthMm": 960, "heightMm": 960, "itemName": "Mild Steel Open 960mm x 960mm", "sourceKey": "led:cabinet:cabinet_outdoor_mild_steel_open_960x960", "catalogRole": "base", "displayType": "outdoor", "variantCode": "open", "materialCode": "mild_steel", "variantLabel": "Open", "materialLabel": "Mild Steel", "sourceCatalog": "static-js", "modulesPerCabinet": 18 },
    { "id": "cabinet_outdoor_mild_steel_open_1280x1280", "unit": "Pcs", "brand": "", "label": "1280mm x 1280mm", "model": "", "price": 8000, "sizeKey": "1280x1280", "widthMm": 1280, "heightMm": 1280, "itemName": "Mild Steel Open 1280mm x 1280mm", "sourceKey": "led:cabinet:cabinet_outdoor_mild_steel_open_1280x1280", "catalogRole": "base", "displayType": "outdoor", "variantCode": "open", "materialCode": "mild_steel", "variantLabel": "Open", "materialLabel": "Mild Steel", "sourceCatalog": "static-js", "modulesPerCabinet": 32 },
    { "id": "cabinet_outdoor_mild_steel_backdoor_640x480", "unit": "Pcs", "brand": "", "label": "640mm x 480mm", "model": "", "price": 8000, "sizeKey": "640x480", "widthMm": 640, "heightMm": 480, "itemName": "Mild Steel Backdoor 640mm x 480mm", "sourceKey": "led:cabinet:cabinet_outdoor_mild_steel_backdoor_640x480", "catalogRole": "base", "displayType": "outdoor", "variantCode": "backdoor", "materialCode": "mild_steel", "variantLabel": "Backdoor", "materialLabel": "Mild Steel", "sourceCatalog": "static-js", "modulesPerCabinet": 6 },
    { "id": "cabinet_outdoor_mild_steel_backdoor_640x640", "unit": "Pcs", "brand": "", "label": "640mm x 640mm", "model": "", "price": 8000, "sizeKey": "640x640", "widthMm": 640, "heightMm": 640, "itemName": "Mild Steel Backdoor 640mm x 640mm", "sourceKey": "led:cabinet:cabinet_outdoor_mild_steel_backdoor_640x640", "catalogRole": "base", "displayType": "outdoor", "variantCode": "backdoor", "materialCode": "mild_steel", "variantLabel": "Backdoor", "materialLabel": "Mild Steel", "sourceCatalog": "static-js", "modulesPerCabinet": 8 },
    { "id": "cabinet_outdoor_mild_steel_backdoor_960x960", "unit": "Pcs", "brand": "", "label": "960mm x 960mm", "model": "", "price": 8000, "sizeKey": "960x960", "widthMm": 960, "heightMm": 960, "itemName": "Mild Steel Backdoor 960mm x 960mm", "sourceKey": "led:cabinet:cabinet_outdoor_mild_steel_backdoor_960x960", "catalogRole": "base", "displayType": "outdoor", "variantCode": "backdoor", "materialCode": "mild_steel", "variantLabel": "Backdoor", "materialLabel": "Mild Steel", "sourceCatalog": "static-js", "modulesPerCabinet": 18 },
    { "id": "cabinet_outdoor_mild_steel_backdoor_1280x1280", "unit": "Pcs", "brand": "", "label": "1280mm x 1280mm", "model": "", "price": 8000, "sizeKey": "1280x1280", "widthMm": 1280, "heightMm": 1280, "itemName": "Mild Steel Backdoor 1280mm x 1280mm", "sourceKey": "led:cabinet:cabinet_outdoor_mild_steel_backdoor_1280x1280", "catalogRole": "base", "displayType": "outdoor", "variantCode": "backdoor", "materialCode": "mild_steel", "variantLabel": "Backdoor", "materialLabel": "Mild Steel", "sourceCatalog": "static-js", "modulesPerCabinet": 32 },
    { "id": "cabinet_outdoor_magnesium_640x480", "unit": "Pcs", "brand": "", "label": "640mm x 480mm", "model": "", "price": 8000, "sizeKey": "640x480", "widthMm": 640, "heightMm": 480, "itemName": "Magnesium 640mm x 480mm", "sourceKey": "led:cabinet:cabinet_outdoor_magnesium_640x480", "catalogRole": "base", "displayType": "outdoor", "variantCode": "", "materialCode": "magnesium", "variantLabel": "", "materialLabel": "Magnesium", "sourceCatalog": "static-js", "modulesPerCabinet": 6 },
    { "id": "cabinet_outdoor_magnesium_640x640", "unit": "Pcs", "brand": "", "label": "640mm x 640mm", "model": "", "price": 8000, "sizeKey": "640x640", "widthMm": 640, "heightMm": 640, "itemName": "Magnesium 640mm x 640mm", "sourceKey": "led:cabinet:cabinet_outdoor_magnesium_640x640", "catalogRole": "base", "displayType": "outdoor", "variantCode": "", "materialCode": "magnesium", "variantLabel": "", "materialLabel": "Magnesium", "sourceCatalog": "static-js", "modulesPerCabinet": 8 },
    { "id": "cabinet_outdoor_magnesium_960x960", "unit": "Pcs", "brand": "", "label": "960mm x 960mm", "model": "", "price": 8000, "sizeKey": "960x960", "widthMm": 960, "heightMm": 960, "itemName": "Magnesium 960mm x 960mm", "sourceKey": "led:cabinet:cabinet_outdoor_magnesium_960x960", "catalogRole": "base", "displayType": "outdoor", "variantCode": "", "materialCode": "magnesium", "variantLabel": "", "materialLabel": "Magnesium", "sourceCatalog": "static-js", "modulesPerCabinet": 18 },
    { "id": "cabinet_outdoor_magnesium_1280x1280", "unit": "Pcs", "brand": "", "label": "1280mm x 1280mm", "model": "", "price": 8000, "sizeKey": "1280x1280", "widthMm": 1280, "heightMm": 1280, "itemName": "Magnesium 1280mm x 1280mm", "sourceKey": "led:cabinet:cabinet_outdoor_magnesium_1280x1280", "catalogRole": "base", "displayType": "outdoor", "variantCode": "", "materialCode": "magnesium", "variantLabel": "", "materialLabel": "Magnesium", "sourceCatalog": "static-js", "modulesPerCabinet": 32 },
    { "id": "cabinet_outdoor_aluminium_640x480", "unit": "Pcs", "brand": "", "label": "640mm x 480mm", "model": "", "price": 8000, "sizeKey": "640x480", "widthMm": 640, "heightMm": 480, "itemName": "Aluminium 640mm x 480mm", "sourceKey": "led:cabinet:cabinet_outdoor_aluminium_640x480", "catalogRole": "base", "displayType": "outdoor", "variantCode": "", "materialCode": "aluminium", "variantLabel": "", "materialLabel": "Aluminium", "sourceCatalog": "static-js", "modulesPerCabinet": 6 },
    { "id": "cabinet_outdoor_aluminium_640x640", "unit": "Pcs", "brand": "", "label": "640mm x 640mm", "model": "", "price": 8000, "sizeKey": "640x640", "widthMm": 640, "heightMm": 640, "itemName": "Aluminium 640mm x 640mm", "sourceKey": "led:cabinet:cabinet_outdoor_aluminium_640x640", "catalogRole": "base", "displayType": "outdoor", "variantCode": "", "materialCode": "aluminium", "variantLabel": "", "materialLabel": "Aluminium", "sourceCatalog": "static-js", "modulesPerCabinet": 8 },
    { "id": "cabinet_outdoor_aluminium_960x960", "unit": "Pcs", "brand": "", "label": "960mm x 960mm", "model": "", "price": 8000, "sizeKey": "960x960", "widthMm": 960, "heightMm": 960, "itemName": "Aluminium 960mm x 960mm", "sourceKey": "led:cabinet:cabinet_outdoor_aluminium_960x960", "catalogRole": "base", "displayType": "outdoor", "variantCode": "", "materialCode": "aluminium", "variantLabel": "", "materialLabel": "Aluminium", "sourceCatalog": "static-js", "modulesPerCabinet": 18 },
    { "id": "cabinet_outdoor_aluminium_1280x1280", "unit": "Pcs", "brand": "", "label": "1280mm x 1280mm", "model": "", "price": 8000, "sizeKey": "1280x1280", "widthMm": 1280, "heightMm": 1280, "itemName": "Aluminium 1280mm x 1280mm", "sourceKey": "led:cabinet:cabinet_outdoor_aluminium_1280x1280", "catalogRole": "base", "displayType": "outdoor", "variantCode": "", "materialCode": "aluminium", "variantLabel": "", "materialLabel": "Aluminium", "sourceCatalog": "static-js", "modulesPerCabinet": 32 }
  ],
  "cabinetSizes": [
    { "id": "cabinet_640x480", "label": "640mm x 480mm", "widthMm": 640, "heightMm": 480, "modulesPerCabinet": 6 },
    { "id": "cabinet_640x640", "label": "640mm x 640mm", "widthMm": 640, "heightMm": 640, "modulesPerCabinet": 8 }
  ],
  "physical": {
    "ft320": 1.0499,
    "ft160": 0.5249,
    "ft192": 0.6299,
    "ft250": 0.8202
  },
  "moduleRes": {
    "2": {
      "pxW": 160,
      "pxH": 80
    },
    "3": {
      "pxW": 64,
      "pxH": 64
    },
    "4": {
      "pxW": 80,
      "pxH": 40
    },
    "5": {
      "pxW": 64,
      "pxH": 32
    },
    "6": {
      "pxW": 32,
      "pxH": 32
    },
    "8": {
      "pxW": 40,
      "pxH": 20
    },
    "10": {
      "pxW": 32,
      "pxH": 16
    },
    "1.25": {
      "pxW": 256,
      "pxH": 128
    },
    "1.53": {
      "pxW": 210,
      "pxH": 105
    },
    "1.667": {
      "pxW": 192,
      "pxH": 96
    },
    "1.86": {
      "pxW": 172,
      "pxH": 86
    },
    "2.5": {
      "pxW": 128,
      "pxH": 64
    },
    "3.076": {
      "pxW": 104,
      "pxH": 52
    },
    "3.91": {
      "pxW": 64,
      "pxH": 64
    },
    "6.67": {
      "pxW": 48,
      "pxH": 24
    }
  },
  "rcCapacityHuidu": {
    "indoor": {
      "2": 10,
      "3": 12,
      "4": 16,
      "5": 16,
      "1.25": 3,
      "1.53": 4,
      "1.667": 5,
      "1.86": 6,
      "2.5": 10,
      "3.076": 16
    },
    "outdoor": {
      "3": 12,
      "4": 16,
      "5": 16,
      "6": 24,
      "8": 30,
      "10": 32,
      "2.5": 10,
      "3.076": 16,
      "3.91": 4,
      "6.67": 24
    }
  },
  "rcCapacityNovastar": {
    "indoor": {
      "2": 10,
      "3": 12,
      "4": 16,
      "5": 16,
      "1.25": 3,
      "1.53": 4,
      "1.667": 5,
      "1.86": 6,
      "2.5": 10,
      "3.076": 16
    },
    "outdoor": {
      "3": 12,
      "4": 16,
      "5": 16,
      "6": 24,
      "8": 30,
      "10": 32,
      "2.5": 10,
      "3.076": 16,
      "3.91": 4,
      "6.67": 24
    }
  },
  "psuCapacity": {
    "indoor": {
      "2": 6,
      "3": 6,
      "4": 6,
      "5": 6,
      "1.25": 4,
      "1.53": 4,
      "1.667": 4,
      "1.86": 5,
      "2.5": 6,
      "3.076": 6
    },
    "outdoor": {
      "3": 6,
      "4": 6,
      "5": 6,
      "6": 6,
      "8": 6,
      "10": 6,
      "2.5": 6,
      "3.076": 6,
      "3.91": 6,
      "6.67": 6,
      "6.7": 6
    }
  },
  "moduleBrandModelIds": {
    "Absen": [
      "cob-in-p1_25",
      "gob-in-p1_25",
      "smd-in-p1_25",
      "gob-in-p1_53",
      "cob-in-p1_53",
      "smd-in-p1_53",
      "cob-in-p1_86",
      "smd-in-p1_86",
      "gob-in-p1_86",
      "smd-out-p10",
      "gob-in-p2",
      "smd-in-p2",
      "gob-in-p2.5",
      "smd-in-p2_5",
      "smd-out-p2_5",
      "smd-in-p3",
      "gob-in-p3",
      "smd-out-p3",
      "smd-out-p3.91",
      "smd-out-p4",
      "smd-out-p5",
      "smd-out-p6",
      "smd-out-p6_67",
      "smd-out-p8"
    ],
    "Lampro": [
      "smd-in-p1_25",
      "gob-in-p1_25",
      "cob-in-p1_25",
      "smd-in-p1_53",
      "cob-in-p1_53",
      "gob-in-p1_53",
      "smd-in-p1_86",
      "cob-in-p1_86",
      "gob-in-p1_86",
      "smd-out-p10",
      "gob-in-p2",
      "smd-in-p2",
      "smd-in-p2_5",
      "gob-in-p2.5",
      "smd-out-p2_5",
      "gob-in-p3",
      "smd-in-p3",
      "smd-out-p3",
      "smd-out-p3.91",
      "smd-out-p4",
      "smd-out-p5",
      "smd-out-p6",
      "smd-out-p6_67",
      "smd-out-p8"
    ],
    "Leyard": [
      "gob-in-p1_25",
      "smd-in-p1_25",
      "cob-in-p1_25",
      "gob-in-p1_53",
      "cob-in-p1_53",
      "smd-in-p1_53",
      "gob-in-p1_86",
      "smd-in-p1_86",
      "cob-in-p1_86",
      "smd-out-p10",
      "gob-in-p2",
      "smd-in-p2",
      "smd-in-p2_5",
      "gob-in-p2.5",
      "smd-out-p2_5",
      "smd-in-p3",
      "gob-in-p3",
      "smd-out-p3",
      "smd-out-p3.91",
      "smd-out-p4",
      "smd-out-p5",
      "smd-out-p6",
      "smd-out-p6_67",
      "smd-out-p8"
    ],
    "Synoveta": [
      "smd-in-p1_25",
      "cob-in-p1_25",
      "gob-in-p1_25",
      "cob-in-p1_53",
      "smd-in-p1_53",
      "gob-in-p1_53",
      "cob-in-p1_86",
      "smd-in-p1_86",
      "gob-in-p1_86",
      "smd-out-p10",
      "gob-in-p2",
      "smd-in-p2",
      "gob-in-p2.5",
      "smd-in-p2_5",
      "smd-out-p2_5",
      "gob-in-p3",
      "smd-in-p3",
      "smd-out-p3",
      "smd-out-p3.91",
      "smd-out-p4",
      "smd-out-p5",
      "smd-out-p6",
      "smd-out-p6_67",
      "smd-out-p8"
    ]
  },
  "moduleBrandLabels": {
    "Lampro": {
      "smd-in-p1_25": "P 1.25 indoor LED Display Module",
      "smd-in-p1_53": "P 1.53 indoor LED Display Module",
      "smd-in-p1_86": "P 1.86 indoor LED Display Module",
      "smd-in-p2": "P 2 indoor LED Display Module",
      "smd-in-p2_5": "P 2.5 indoor LED Display Module",
      "smd-in-p3": "P 3 indoor LED Display Module",
      "smd-out-p2_5": "P 2.5 outdoor LED Display Module",
      "smd-out-p3": "P 3 outdoor LED Display Module",
      "smd-out-p3.91": "P 3.91 outdoor LED Display Module",
      "smd-out-p4": "P 4 outdoor LED Display Module",
      "smd-out-p5": "P 5 outdoor LED Display Module",
      "smd-out-p6": "P 6 outdoor LED Display Module",
      "smd-out-p6_67": "P 6.67 outdoor LED Display Module",
      "smd-out-p8": "P 8 outdoor LED Display Module",
      "smd-out-p10": "P 10 outdoor LED Display Module",
      "gob-in-p1_25": "P 1.25 indoor LED Display Module",
      "gob-in-p1_53": "P 1.53 indoor LED Display Module",
      "gob-in-p1_86": "P 1.86 indoor LED Display Module",
      "gob-in-p2": "P 2 indoor LED Display Module",
      "gob-in-p2.5": "P 2.5 indoor LED Display Module",
      "gob-in-p3": "P 3 indoor LED Display Module",
      "cob-in-p1_25": "P 1.25 indoor LED Display Module",
      "cob-in-p1_53": "P 1.53 indoor LED Display Module",
      "cob-in-p1_86": "P 1.86 indoor LED Display Module"
    },
    "Absen": {
      "smd-in-p1_25": "P 1.25 indoor LED Display Module",
      "smd-in-p1_53": "P 1.53 indoor LED Display Module",
      "smd-in-p1_86": "P 1.86 indoor LED Display Module",
      "smd-in-p2": "P 2 indoor LED Display Module",
      "smd-in-p2_5": "P 2.5 indoor LED Display Module",
      "smd-in-p3": "P 3 indoor LED Display Module",
      "smd-out-p2_5": "P 2.5 outdoor LED Display Module",
      "smd-out-p3": "P 3 outdoor LED Display Module",
      "smd-out-p3.91": "P 3.91 outdoor LED Display Module",
      "smd-out-p4": "P 4 outdoor LED Display Module",
      "smd-out-p5": "P 5 outdoor LED Display Module",
      "smd-out-p6": "P 6 outdoor LED Display Module",
      "smd-out-p6_67": "P 6.67 outdoor LED Display Module",
      "smd-out-p8": "P 8 outdoor LED Display Module",
      "smd-out-p10": "P 10 outdoor LED Display Module",
      "gob-in-p1_25": "P 1.25 indoor LED Display Module",
      "gob-in-p1_53": "P 1.53 indoor LED Display Module",
      "gob-in-p1_86": "P 1.86 indoor LED Display Module",
      "gob-in-p2": "P 2 indoor LED Display Module",
      "gob-in-p2.5": "P 2.5 indoor LED Display Module",
      "gob-in-p3": "P 3 indoor LED Display Module",
      "cob-in-p1_25": "P 1.25 indoor LED Display Module",
      "cob-in-p1_53": "P 1.53 indoor LED Display Module",
      "cob-in-p1_86": "P 1.86 indoor LED Display Module"
    },
    "Leyard": {
      "smd-in-p1_25": "P 1.25 indoor LED Display Module",
      "smd-in-p1_53": "P 1.53 indoor LED Display Module",
      "smd-in-p1_86": "P 1.86 indoor LED Display Module",
      "smd-in-p2": "P 2 indoor LED Display Module",
      "smd-in-p2_5": "P 2.5 indoor LED Display Module",
      "smd-in-p3": "P 3 indoor LED Display Module",
      "smd-out-p2_5": "P 2.5 outdoor LED Display Module",
      "smd-out-p3": "P 3 outdoor LED Display Module",
      "smd-out-p3.91": "P 3.91 outdoor LED Display Module",
      "smd-out-p4": "P 4 outdoor LED Display Module",
      "smd-out-p5": "P 5 outdoor LED Display Module",
      "smd-out-p6": "P 6 outdoor LED Display Module",
      "smd-out-p6_67": "P 6.67 outdoor LED Display Module",
      "smd-out-p8": "P 8 outdoor LED Display Module",
      "smd-out-p10": "P 10 outdoor LED Display Module",
      "gob-in-p1_25": "P 1.25 indoor LED Display Module",
      "gob-in-p1_53": "P 1.53 indoor LED Display Module",
      "gob-in-p1_86": "P 1.86 indoor LED Display Module",
      "gob-in-p2": "P 2 indoor LED Display Module",
      "gob-in-p2.5": "P 2.5 indoor LED Display Module",
      "gob-in-p3": "P 3 indoor LED Display Module",
      "cob-in-p1_25": "P 1.25 indoor LED Display Module",
      "cob-in-p1_53": "P 1.53 indoor LED Display Module",
      "cob-in-p1_86": "P 1.86 indoor LED Display Module"
    },
    "Synoveta": {
      "smd-in-p1_25": "P 1.25 indoor LED Display Module",
      "smd-in-p1_53": "P 1.53 indoor LED Display Module",
      "smd-in-p1_86": "P 1.86 indoor LED Display Module",
      "smd-in-p2": "P 2 indoor LED Display Module",
      "smd-in-p2_5": "P 2.5 indoor LED Display Module",
      "smd-in-p3": "P 3 indoor LED Display Module",
      "smd-out-p2_5": "P 2.5 outdoor LED Display Module",
      "smd-out-p3": "P 3 outdoor LED Display Module",
      "smd-out-p3.91": "P 3.91 outdoor LED Display Module",
      "smd-out-p4": "P 4 outdoor LED Display Module",
      "smd-out-p5": "P 5 outdoor LED Display Module",
      "smd-out-p6": "P 6 outdoor LED Display Module",
      "smd-out-p6_67": "P 6.67 outdoor LED Display Module",
      "smd-out-p8": "P 8 outdoor LED Display Module",
      "smd-out-p10": "P 10 outdoor LED Display Module",
      "gob-in-p1_25": "P 1.25 indoor LED Display Module",
      "gob-in-p1_53": "P 1.53 indoor LED Display Module",
      "gob-in-p1_86": "P 1.86 indoor LED Display Module",
      "gob-in-p2": "P 2 indoor LED Display Module",
      "gob-in-p2.5": "P 2.5 indoor LED Display Module",
      "gob-in-p3": "P 3 indoor LED Display Module",
      "cob-in-p1_25": "P 1.25 indoor LED Display Module",
      "cob-in-p1_53": "P 1.53 indoor LED Display Module",
      "cob-in-p1_86": "P 1.86 indoor LED Display Module"
    }
  },
  "moduleBrandDetails": {
    "Lampro": {
      "smd-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC1.25P",
        "unit": "Pcs"
      },
      "smd-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC1.53P",
        "unit": "Pcs"
      },
      "smd-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC1.86P",
        "unit": "Pcs"
      },
      "smd-in-p2": {
        "itemName": "P 2 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC2P",
        "unit": "Pcs"
      },
      "smd-in-p2_5": {
        "itemName": "P 2.5 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC2.5P",
        "unit": "Pcs"
      },
      "smd-in-p3": {
        "itemName": "P 3 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC3P",
        "unit": "Pcs"
      },
      "smd-out-p2_5": {
        "itemName": "P 2.5 outdoor LED Display Module",
        "brand": "Lampro",
        "model": "LC2.5PO",
        "unit": "Pcs"
      },
      "smd-out-p3": {
        "itemName": "P 3 outdoor LED Display Module",
        "brand": "Lampro",
        "model": "LC3.076PO",
        "unit": "Pcs"
      },
      "smd-out-p3.91": {
        "itemName": "P 3.91 outdoor LED Display Module",
        "brand": "Lampro",
        "model": "LR3.91O",
        "unit": "Pcs"
      },
      "smd-out-p4": {
        "itemName": "P 4 outdoor LED Display Module",
        "brand": "Lampro",
        "model": "LC4PO",
        "unit": "Pcs"
      },
      "smd-out-p5": {
        "itemName": "P 5 outdoor LED Display Module",
        "brand": "Lampro",
        "model": "LC5PO",
        "unit": "Pcs"
      },
      "smd-out-p6": {
        "itemName": "P 6 outdoor LED Display Module",
        "brand": "Lampro",
        "model": "LC6PO",
        "unit": "Pcs"
      },
      "smd-out-p6_67": {
        "itemName": "P 6.67 outdoor LED Display Module",
        "brand": "Lampro",
        "model": "LC6.667PO",
        "unit": "Pcs"
      },
      "smd-out-p8": {
        "itemName": "P 8 outdoor LED Display Module",
        "brand": "Lampro",
        "model": "LC8PO",
        "unit": "Pcs"
      },
      "smd-out-p10": {
        "itemName": "P 10 outdoor LED Display Module",
        "brand": "Lampro",
        "model": "LC10PO",
        "unit": "Pcs"
      },
      "gob-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC1.25P GOB",
        "unit": "Pcs"
      },
      "gob-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC1.53P GOB",
        "unit": "Pcs"
      },
      "gob-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC1.86P GOB",
        "unit": "Pcs"
      },
      "gob-in-p2": {
        "itemName": "P 2 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC2P GOB",
        "unit": "Pcs"
      },
      "gob-in-p2.5": {
        "itemName": "P 2.5 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC2.5P GOB",
        "unit": "Pcs"
      },
      "gob-in-p3": {
        "itemName": "P 3 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC3P GOB",
        "unit": "Pcs"
      },
      "cob-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC COB 1.25",
        "unit": "Pcs"
      },
      "cob-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC COB 1.53",
        "unit": "Pcs"
      },
      "cob-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Lampro",
        "model": "LC COB 1.86",
        "unit": "Pcs"
      }
    },
    "Absen": {
      "smd-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Absen",
        "model": "P1.25",
        "unit": "Pcs"
      },
      "smd-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Absen",
        "model": "P1.53",
        "unit": "Pcs"
      },
      "smd-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Absen",
        "model": "P1.86",
        "unit": "Pcs"
      },
      "smd-in-p2": {
        "itemName": "P 2 indoor LED Display Module",
        "brand": "Absen",
        "model": "P2",
        "unit": "Pcs"
      },
      "smd-in-p2_5": {
        "itemName": "P 2.5 indoor LED Display Module",
        "brand": "Absen",
        "model": "P2.5",
        "unit": "Pcs"
      },
      "smd-in-p3": {
        "itemName": "P 3 indoor LED Display Module",
        "brand": "Absen",
        "model": "P3",
        "unit": "Pcs"
      },
      "smd-out-p2_5": {
        "itemName": "P 2.5 outdoor LED Display Module",
        "brand": "Absen",
        "model": "P2.5",
        "unit": "Pcs"
      },
      "smd-out-p3": {
        "itemName": "P 3 outdoor LED Display Module",
        "brand": "Absen",
        "model": "P3",
        "unit": "Pcs"
      },
      "smd-out-p3.91": {
        "itemName": "P 3.91 outdoor LED Display Module",
        "brand": "Absen",
        "model": "P3.91",
        "unit": "Pcs"
      },
      "smd-out-p4": {
        "itemName": "P 4 outdoor LED Display Module",
        "brand": "Absen",
        "model": "P4",
        "unit": "Pcs"
      },
      "smd-out-p5": {
        "itemName": "P 5 outdoor LED Display Module",
        "brand": "Absen",
        "model": "P5",
        "unit": "Pcs"
      },
      "smd-out-p6": {
        "itemName": "P 6 outdoor LED Display Module",
        "brand": "Absen",
        "model": "P6",
        "unit": "Pcs"
      },
      "smd-out-p6_67": {
        "itemName": "P 6.67 outdoor LED Display Module",
        "brand": "Absen",
        "model": "P6.67",
        "unit": "Pcs"
      },
      "smd-out-p8": {
        "itemName": "P 8 outdoor LED Display Module",
        "brand": "Absen",
        "model": "P8",
        "unit": "Pcs"
      },
      "smd-out-p10": {
        "itemName": "P 10 outdoor LED Display Module",
        "brand": "Absen",
        "model": "P10",
        "unit": "Pcs"
      },
      "gob-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Absen",
        "model": "P1.25",
        "unit": "Pcs"
      },
      "gob-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Absen",
        "model": "P1.53",
        "unit": "Pcs"
      },
      "gob-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Absen",
        "model": "P1.86",
        "unit": "Pcs"
      },
      "gob-in-p2": {
        "itemName": "P 2 indoor LED Display Module",
        "brand": "Absen",
        "model": "P2",
        "unit": "Pcs"
      },
      "gob-in-p2.5": {
        "itemName": "P 2.5 indoor LED Display Module",
        "brand": "Absen",
        "model": "P2.5",
        "unit": "Pcs"
      },
      "gob-in-p3": {
        "itemName": "P 3 indoor LED Display Module",
        "brand": "Absen",
        "model": "P3",
        "unit": "Pcs"
      },
      "cob-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Absen",
        "model": "P1.25",
        "unit": "Pcs"
      },
      "cob-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Absen",
        "model": "P1.53",
        "unit": "Pcs"
      },
      "cob-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Absen",
        "model": "P1.86",
        "unit": "Pcs"
      }
    },
    "Leyard": {
      "smd-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P1.25",
        "unit": "Pcs"
      },
      "smd-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P1.53",
        "unit": "Pcs"
      },
      "smd-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P1.86",
        "unit": "Pcs"
      },
      "smd-in-p2": {
        "itemName": "P 2 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P2",
        "unit": "Pcs"
      },
      "smd-in-p2_5": {
        "itemName": "P 2.5 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P2.5",
        "unit": "Pcs"
      },
      "smd-in-p3": {
        "itemName": "P 3 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P3",
        "unit": "Pcs"
      },
      "smd-out-p2_5": {
        "itemName": "P 2.5 outdoor LED Display Module",
        "brand": "Leyard",
        "model": "P2.5",
        "unit": "Pcs"
      },
      "smd-out-p3": {
        "itemName": "P 3 outdoor LED Display Module",
        "brand": "Leyard",
        "model": "P3",
        "unit": "Pcs"
      },
      "smd-out-p3.91": {
        "itemName": "P 3.91 outdoor LED Display Module",
        "brand": "Leyard",
        "model": "P3.91",
        "unit": "Pcs"
      },
      "smd-out-p4": {
        "itemName": "P 4 outdoor LED Display Module",
        "brand": "Leyard",
        "model": "P4",
        "unit": "Pcs"
      },
      "smd-out-p5": {
        "itemName": "P 5 outdoor LED Display Module",
        "brand": "Leyard",
        "model": "P5",
        "unit": "Pcs"
      },
      "smd-out-p6": {
        "itemName": "P 6 outdoor LED Display Module",
        "brand": "Leyard",
        "model": "P6",
        "unit": "Pcs"
      },
      "smd-out-p6_67": {
        "itemName": "P 6.67 outdoor LED Display Module",
        "brand": "Leyard",
        "model": "P6.67",
        "unit": "Pcs"
      },
      "smd-out-p8": {
        "itemName": "P 8 outdoor LED Display Module",
        "brand": "Leyard",
        "model": "P8",
        "unit": "Pcs"
      },
      "smd-out-p10": {
        "itemName": "P 10 outdoor LED Display Module",
        "brand": "Leyard",
        "model": "P10",
        "unit": "Pcs"
      },
      "gob-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P1.25",
        "unit": "Pcs"
      },
      "gob-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P1.53",
        "unit": "Pcs"
      },
      "gob-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P1.86",
        "unit": "Pcs"
      },
      "gob-in-p2": {
        "itemName": "P 2 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P2",
        "unit": "Pcs"
      },
      "gob-in-p2.5": {
        "itemName": "P 2.5 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P2.5",
        "unit": "Pcs"
      },
      "gob-in-p3": {
        "itemName": "P 3 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P3",
        "unit": "Pcs"
      },
      "cob-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P1.25",
        "unit": "Pcs"
      },
      "cob-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P1.53",
        "unit": "Pcs"
      },
      "cob-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Leyard",
        "model": "P1.86",
        "unit": "Pcs"
      }
    },
    "Synoveta": {
      "smd-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "SVC 1.25P",
        "unit": "Pcs"
      },
      "smd-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "SVC 1.53P",
        "unit": "Pcs"
      },
      "smd-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "SVC 1.86P",
        "unit": "Pcs"
      },
      "smd-in-p2": {
        "itemName": "P 2 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "P2",
        "unit": "Pcs"
      },
      "smd-in-p2_5": {
        "itemName": "P 2.5 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "P2.5",
        "unit": "Pcs"
      },
      "smd-in-p3": {
        "itemName": "P 3 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "P3",
        "unit": "Pcs"
      },
      "smd-out-p2_5": {
        "itemName": "P 2.5 outdoor LED Display Module",
        "brand": "Synoveta",
        "model": "P2.5",
        "unit": "Pcs"
      },
      "smd-out-p3": {
        "itemName": "P 3 outdoor LED Display Module",
        "brand": "Synoveta",
        "model": "P3",
        "unit": "Pcs"
      },
      "smd-out-p3.91": {
        "itemName": "P 3.91 outdoor LED Display Module",
        "brand": "Synoveta",
        "model": "P3.91",
        "unit": "Pcs"
      },
      "smd-out-p4": {
        "itemName": "P 4 outdoor LED Display Module",
        "brand": "Synoveta",
        "model": "P4",
        "unit": "Pcs"
      },
      "smd-out-p5": {
        "itemName": "P 5 outdoor LED Display Module",
        "brand": "Synoveta",
        "model": "P5",
        "unit": "Pcs"
      },
      "smd-out-p6": {
        "itemName": "P 6 outdoor LED Display Module",
        "brand": "Synoveta",
        "model": "P6",
        "unit": "Pcs"
      },
      "smd-out-p6_67": {
        "itemName": "P 6.67 outdoor LED Display Module",
        "brand": "Synoveta",
        "model": "P6.67",
        "unit": "Pcs"
      },
      "smd-out-p8": {
        "itemName": "P 8 outdoor LED Display Module",
        "brand": "Synoveta",
        "model": "P8",
        "unit": "Pcs"
      },
      "smd-out-p10": {
        "itemName": "P 10 outdoor LED Display Module",
        "brand": "Synoveta",
        "model": "P10",
        "unit": "Pcs"
      },
      "gob-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "P1.25",
        "unit": "Pcs"
      },
      "gob-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "P1.53",
        "unit": "Pcs"
      },
      "gob-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "P1.86",
        "unit": "Pcs"
      },
      "gob-in-p2": {
        "itemName": "P 2 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "P2",
        "unit": "Pcs"
      },
      "gob-in-p2.5": {
        "itemName": "P 2.5 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "P2.5",
        "unit": "Pcs"
      },
      "gob-in-p3": {
        "itemName": "P 3 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "P3",
        "unit": "Pcs"
      },
      "cob-in-p1_25": {
        "itemName": "P 1.25 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "SVC 1.25P",
        "unit": "Pcs"
      },
      "cob-in-p1_53": {
        "itemName": "P 1.53 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "SVC 1.53P",
        "unit": "Pcs"
      },
      "cob-in-p1_86": {
        "itemName": "P 1.86 indoor LED Display Module",
        "brand": "Synoveta",
        "model": "SVC 1.86P",
        "unit": "Pcs"
      }
    }
  },
  "cabinetBrands": []
};

export function getCabinetFootprintFt(physical, cabinetSizeId = "cabinet_indoor_aluminium_640x480", cabinetOptions = []) {
  const p = physical || componentModelAndPrice.physical;
  const option = (cabinetOptions?.length ? cabinetOptions : componentModelAndPrice.cabinetOptions).find(
    (cabinet) => cabinet.id === cabinetSizeId
  );

  if (option?.widthMm && option?.heightMm) {
    return { w: option.widthMm / 304.8, h: option.heightMm / 304.8 };
  }

  if (cabinetSizeId === "cabinet_640x640") return { w: p.ft320 * 2, h: p.ft320 * 2 };
  return { w: p.ft320 * 2, h: p.ft160 * 3 };
}
